export class DriverLicense {
  type: string;
  front: string;
  back: string;
  categories: string[] = [];
}
